import { state } from '@/store';

/**
 * После успешной загрузки чека виджет оставляет модалку; клик по затемнению (вне #apm-modal-body)
 * закрывает её так же, как кнопка #apm-close-widget-button.
 * Не срабатывает во время активной загрузки (state.isUploadOpened).
 */
export function tryCloseApmModalOnBackdropClick(event) {
  if (!(state.checkSoon && !state.isUploadOpened)) return false;
  const modal = document.getElementById('apm-modal');
  if (!modal || !modal.isConnected) return false;
  const t = event.target;
  if (!t || typeof t.closest !== 'function') return false;
  if (!modal.contains(t)) return false;
  if (t.closest('#apm-modal-body')) return false;
  const closeBtn = document.getElementById('apm-close-widget-button');
  if (!closeBtn) return false;
  closeBtn.click();
  return true;
}
